import type { PracticeScope } from "./lume-events";

export interface PraticaSessaoSearch {
  materia?: number;
  tema?: number;
  topicos?: number[];
  rotulo?: string;
  modo?: "completo";
}

const MAX_TOPICOS = 60;

/**
 * `?topicos=` as the router hands it over: a JSON array from an in-app link, a
 * bare number for a single id, or "12,34,56" typed or sent by the agent.
 */
export function parseIdList(value: unknown): number[] {
  const raw = Array.isArray(value)
    ? value
    : typeof value === "string"
      ? value.split(",")
      : [value];

  const ids = new Set<number>();
  raw.forEach((item) => {
    const id = Number(typeof item === "string" ? item.trim() : item);
    if (Number.isInteger(id) && id > 0) {
      ids.add(id);
    }
  });

  return [...ids].slice(0, MAX_TOPICOS);
}

export function practiceScopeOf(search: PraticaSessaoSearch): PracticeScope {
  if (search.topicos !== undefined) {
    return search.topicos.length === 1 ? "topico" : "conjunto";
  }
  if (search.tema !== undefined) {
    return "tema";
  }

  return search.materia !== undefined ? "materia" : "tudo";
}
